import Typography from '@mui/material/Typography';
import { useOpenCreateLifeArea } from 'features/life-areas';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TopBarBase } from 'shared/components/connected/top-bar-base';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';

import * as Styled from './page-top-bar.style';

export const PageTopBar: React.FC = () => {
  const { t } = useTranslation();
  const openDialog = useOpenCreateLifeArea();

  return (
    <TopBarBase>
      <Styled.Container>
        <Styled.Title>
          <Typography variant="h5" component="h1">
            {t('pages.life-areas.title')}
          </Typography>
        </Styled.Title>

        <Styled.Interactions>
          <Button
            onClick={openDialog}
            size={Sizes.Small}
            variant={Variants.Contained}
            color={Colors.Primary}
            preventDrag
          >
            {t('pages.life-areas.header.add-life-area')}
          </Button>
        </Styled.Interactions>
      </Styled.Container>
    </TopBarBase>
  );
};
